import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import './index.css';
import './styles/fonts-tajawal.css';
import './styles/enhancements.css';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import AppProviders from "./providers/AppProviders";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
